import { useState, useEffect } from 'react'
import { Flex, Box, Text, Heading, Card } from 'rebass/styled-components'
import { IInxs } from '../../graphql/types/queries/inxs';
import styled from 'styled-components';
import { HoverableCard } from '../../components/HoverableCard';
import { Link, Outlet, useNavigate, useParams } from 'react-router-dom';
import moment from 'moment';
import { Tag } from '../../components/Tag';
import { MARK_INXS_AS_READ } from '../../graphql/mutations';
import { IMarkInxsMessageAsReadOutput, IMarkInxsMessageAsReadInput } from '../../graphql/types/mutations/inxs'
import { useMutation } from '@apollo/client';
import { GET_INXS, GET_UNREAD_INXS } from '../../graphql/queries';

const Wrapper = styled(Flex)`
  overflow: auto;
  flex-direction: column;
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: #6c89b7;
    border-radius: 5px;
  }
  &::-webkit-scrollbar {
    width: 7px;
    border: 1px solid transparent;
  }
`;
interface IInxsContentProps {
  data: Array<IInxs>
}


const MessageEntry = ({ entry, hoveredId, setHover, selectedConversationId }: { selectedConversationId: string | null | undefined, entry: IInxs, setHover: (id: string | null) => void, hoveredId: string | null }) => {
  const navigate = useNavigate()
  const [markAsRead] = useMutation<IMarkInxsMessageAsReadOutput, IMarkInxsMessageAsReadInput>(MARK_INXS_AS_READ, {
    refetchQueries: [{
      query: GET_UNREAD_INXS
    }, {
      query: GET_INXS
    }],
    awaitRefetchQueries: true
  })
  const isSelected = !!selectedConversationId && selectedConversationId === entry.id.toString()


  let color = '#bababa'

  switch (entry.inxs.severity) {
    case 'ALERT':
      color = '#8a0303'
      break;
    case 'SEVERE':
      color = '#ea0505'
      break;
    case 'INFORMATION':
      color = '#263393'
      break;
    case 'WARNING':
      color = '#cf7003'
      break;

    default:
      break;
  }
  return (
    <HoverableCard onClick={() => {
      navigate(`/inxs/${entry.id}`)
      if (!entry.readAt) {
        markAsRead({
          variables: {
            inxsId: entry.id
          }
        })
      }
    }}
      isEmbed={false}
      id={entry.id.toString()}
      hoveredId={hoveredId}
      setHover={setHover}
      style={{
        border: '0px',
        cursor: 'pointer',
        backgroundColor: isSelected ? '#F2F5F9' : !!entry.readAt ? 'transparent' : '',
        boxShadow: isSelected ? '0px 3.7719px 9.42975px rgba(0, 0, 0, 0.1)' : 'initial',

      }}>
      <Flex style={{ overflow: 'hidden', position: 'relative', borderRadius: '5px' }}>
        <Flex data-tip data-for={`ttTagsConvo${entry.id}`} paddingX={'8px'} paddingY='12px' alignItems={'center'} style={{ overflow: 'hidden', position: 'relative', }}>

          <Flex flexDirection={'column'} flex={1}>
            <Flex >
              <Text fontSize={'15px'} flex={1} fontWeight={isSelected ? 700 : 500}>{entry.inxs.title}</Text>
              {/* <Text fontSize={'13px'} fontWeight={500}>{entry.customerWaitingSince.friendly}</Text> */}
            </Flex>
            <Text fontSize={'13px'} mt={2} fontWeight={500}>{entry.inxs.description.substring(0, 65)}...</Text>
          </Flex>
          <Text>

          </Text>
        </Flex>
        {entry.inxs.severity !== 'INFORMATION' && (
          <>
            <Flex style={{ position: 'absolute', alignItems: 'flex-end', justifyContent: 'centers', top: -15, left: -35, width: 80, background: color, opacity: 0.75, transform: 'rotate(-45deg)' }}>
              <svg style={{ transform: 'rotate(45deg)', marginBottom: 6, marginLeft: 6, opacity: 0 }} width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.5 20.5C5.23478 20.5 4.98043 20.3947 4.79289 20.2071C4.60536 20.0196 4.5 19.7652 4.5 19.5V4.50002C4.5 4.23481 4.60536 3.98045 4.79289 3.79292C4.98043 3.60538 5.23478 3.50002 5.5 3.50002H11.88C12.0664 3.49873 12.2494 3.54954 12.4084 3.64672C12.5674 3.7439 12.6961 3.88359 12.78 4.05002L13.5 5.50002H18.5C18.7652 5.50002 19.0196 5.60538 19.2071 5.79292C19.3946 5.98045 19.5 6.23481 19.5 6.50002V14.5C19.5 14.7652 19.3946 15.0196 19.2071 15.2071C19.0196 15.3947 18.7652 15.5 18.5 15.5H13.11C12.9253 15.4995 12.7444 15.4478 12.5873 15.3507C12.4302 15.2536 12.3031 15.1149 12.22 14.95L11.5 13.5H6.5V19.5C6.5 19.7652 6.39464 20.0196 6.20711 20.2071C6.01957 20.3947 5.76522 20.5 5.5 20.5V20.5ZM6.5 5.50002V11.5H12.5L13.5 13.5H17.5V7.50002H12.5L11.5 5.50002H6.5Z"
                  fill="white"></path></svg>
            </Flex>
          </>
        )}
      </Flex>
    </HoverableCard>
  )
}

const SeverityTag = ({ data }: { data: IInxs }) => {
  let color = '#bababa'

  switch (data.inxs.severity) {
    case 'ALERT':
      color = '#8a0303'
      break;
    case 'SEVERE':
      color = '#ea0505'
      break;
    case 'INFORMATION':
      color = '#263393'
      break;
    case 'WARNING':
      color = '#cf7003'
      break;

    default:
      break;
  }

  return (

    <Tag tag={{
      color: color,
      id: -1,
      tag: data.inxs.severity
    }} />
  )
}

export const InxsContent: React.FC<IInxsContentProps> = ({ data }) => {

  let params = useParams();
  const [hoveredRow, setHoveredRow] = useState<string | null>(null)
  const [selectedEntry, setSelectedEntry] = useState<IInxs | null | undefined>()
  const [entries, setEntries] = useState<IInxs[]>([])
  useEffect(() => {
    let dta = (JSON.parse(JSON.stringify(data)) as IInxs[]).sort((a, b) => {
      console.log({ a, b })
      if (!!a.readAt && !b.readAt) return 1
      if (!a.readAt && !!b.readAt) return -1
      const ma = moment(a.inxs.updatedAt)
      const mb = moment(b.inxs.updatedAt)
      if (ma.isBefore(mb)) return 1
      if (mb.isBefore(ma)) return -1
      return 0
    })
    setEntries(dta)
  }, [])

  useEffect(() => {
    let dta = (JSON.parse(JSON.stringify(data)) as IInxs[]).sort((a, b) => {
      console.log({ a, b })
      if (!!a.readAt && !b.readAt) return 1
      if (!a.readAt && !!b.readAt) return -1
      const ma = moment(a.inxs.updatedAt)
      const mb = moment(b.inxs.updatedAt)
      if (ma.isBefore(mb)) return 1
      if (mb.isBefore(ma)) return -1

      return 0
    })
    setEntries(dta)
  }, [data])
  useEffect(() => {
    if (!!(params || ({} as any))['*']) {
      setSelectedEntry(data.find(x => x.id === (params || ({} as any))['*']))
    } else {
      setSelectedEntry(null)
    }
  }, [params])
  // for (let index = 0; index < 25; index++) {
  //   a.push(data)
  // }
  if (!data || data.length < 1) {
    return <Wrapper style={{ borderRadius: '12px' }} justifyContent={'center'} alignItems={'center'} maxWidth={'400px'} minWidth={'400px'} backgroundColor={'white'}>
      <Text>You have no notifications</Text>
    </Wrapper>
  }

  return (
    <Flex flex={1} maxHeight={'100%'} height={'100%'}>
      <Wrapper maxWidth={'400px'} minWidth={'400px'}>

        {entries.map(x => {
          return (
            <MessageEntry
              selectedConversationId={(params || ({} as any))['*']}
              entry={x} hoveredId={hoveredRow}
              setHover={setHoveredRow}
              key={x.id} />
          )
        })}
      </Wrapper>
      {!!selectedEntry && (

        <Wrapper flex={1} ml={4} backgroundColor={'white'} style={{ borderRadius: '12px', padding: '24px' }}>
          <Flex>
            <Heading>
              {selectedEntry.inxs.title}
            </Heading>
            <Box flex={1} />
            <SeverityTag data={selectedEntry} />
          </Flex>
          <Box mt={4} mb={2} width={'100%'} height={'1px'} style={{
            borderBottom: '1px solid rgba(52, 79, 121, 0.33)'
          }} />
          <Flex>
            <Text>
              {selectedEntry.inxs.creator}
            </Text>
            <Text ml={2} fontWeight={300}>
              sent you a message:
            </Text>
            <Box flex={1} />
            <Text style={{ fontSize: '12px' }}>{moment.duration(moment(selectedEntry.inxs.updatedAt).diff(moment())).humanize()} ago</Text>
          </Flex>

          <Box mt={2} mb={4} width={'100%'} height={'1px'} style={{
            borderBottom: '1px solid rgba(52, 79, 121, 0.33)'
          }} />
          <Text mt={4} style={{whiteSpace: 'pre-wrap'}}>
            {selectedEntry.inxs.description}
          </Text>
          {selectedEntry.inxs.title === 'Form template changed' && (
            <Link style={{ marginTop: '32px' }} to='/form-listing'>Go to my forms</Link>
          )}
        </Wrapper>
      )}
    </Flex>);
}